import React, { useState, useReducer } from "react";

import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { fetchDataGet } from "../../controler/comunicacao";

import localidades from "./cidades";

let filters = [
  {
    titulo: "Escolha a situação",
    opcoes: ["Notificações", "Óbitos", "Interrupções de tratamento"]
  },
  {
    titulo: "Escolha os anos",
    opcoes: ["TODOS", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"]
  },
  {
    titulo: "Escolha a região",
    opcoes: ["TODOS", ...Object.keys(localidades)]
  },
  {
    titulo: "Escolha os estados",
    opcoes: ["TODOS", "SP", "RJ", "MG", "ES", "PR", "SC", "RS", "MS", "MT", "GO", "DF", "BA", "SE", "AL", "PE", "PB", "RN", "CE", "PI", "MA", "PA", "AP", "RR", "AM", "AC", "RO", "TO"]
  },
  {
    titulo: "Escolha as cidades",
    opcoes: [
      "TODOS",
    ]
  },
  {
    titulo: "Escolha raças",
    opcoes: ["TODOS", "Parda", "Branca", "Preta", "Indigena", "Amarela", "Ignorado/sem informacao"]
  },
  {
    titulo: "Escolha o Gênero",
    opcoes: ["TODOS", "Masculino", "Feminino", "Ignorado/sem informacao"]
  },
  {
    titulo: "Escolha as faixas etárias",
    opcoes: [
      "TODOS",
      "0 a 4 anos",
      "5 a 14 anos",
      "15 a 39 anos",
      "40 a 59 anos",
      "60 anos ou mais",
    ]
  }
];

const SECONDS = 1000;
const MINUTES = 60;
const HOURS = 60;
const DAYS = 24;


const useFilters = () => {
  return useQuery({
    queryKey: ["localidades"],
    queryFn: async () => {
      try {
        let result = localidades;
        if (!result) {
          throw new Error("No data received");
        }

        const citiesData = {};
        Object.values(result).forEach(states => {
          Object.entries(states).forEach(([state, cities]) => {
            citiesData[state] = Array.isArray(cities) ? cities.sort() : [];
          });
        });

        return citiesData;
      } catch (error) {
        console.error("Error fetching localities:", error);
        throw error;
      }
    },
    staleTime: SECONDS * MINUTES * HOURS * DAYS * 15,
    cacheTime: SECONDS * MINUTES * HOURS * DAYS * 15,
    refetchOnWindowFocus: false,
    retry: 0
  });
};



const Filters = ({ open = false, useData }) => {
  let filtersRequest = useFilters();

  const { data: anosData } = useQuery({
    queryKey: ['anos-v2'],
    queryFn: () => fetchDataGet('/api/anos'),
    staleTime: SECONDS * MINUTES * HOURS * DAYS * 15,
    refetchOnWindowFocus: false,
    retry: 0,
  });

  useEffect(() => {
    if (anosData) {
      const anosFiltro = filters.find(f => f.titulo === "Escolha os anos");
      anosFiltro.opcoes = ["TODOS", ...anosData];
      forceUpdate();
    }
  }, [anosData]);

  const estadoInicial = filters.reduce((acc, filtro) => {
    let allOption;
    if (filtro.titulo === "Escolha a situação") {
      allOption = filtro.opcoes.find(op => op === "Notificações");
    } else {
      allOption = filtro.opcoes.find(op => op === "TODOS");
    }

    if (allOption) {
      acc[filtro.titulo] = [allOption];
    } else {
      acc[filtro.titulo] = [];
    }
    return acc;
  }, {});

  const [selecionados, setSelecionados] = useState(estadoInicial);
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const updateFilters = () => {
    const estadosFiltro = filters.find(f => f.titulo === "Escolha os estados");
    const cidadesFiltro = filters.find(f => f.titulo === "Escolha as cidades");
    const regioesSelecionadas = selecionados["Escolha a região"].filter(r => r !== "TODOS");
    estadosFiltro.opcoes = ["TODOS"];

    if (regioesSelecionadas.length > 0) {
      let estadosUnicos = new Set();
      regioesSelecionadas.forEach(regiao => {
        if (localidades[regiao]) {
          Object.keys(localidades[regiao]).forEach(estado => estadosUnicos.add(estado));
        }
      });

      estadosFiltro.opcoes = ["TODOS", ...Array.from(estadosUnicos).sort()];
    } else {
      if (selecionados["Escolha os estados"][0] !== "TODOS") {
        setSelecionados(prev => ({
          ...prev,
          "Escolha os estados": ["TODOS"]
        }));
      }
    }

    // Atualiza cidades
    if (selecionados["Escolha os estados"][0] === "TODOS") {
      cidadesFiltro.opcoes = ["TODOS"];
      // Se 'TODOS' for a única opção selecionada em estados, reseta cidades para 'TODOS'
      // Previne loop infinito verificando se já está em TODOS
      if (selecionados["Escolha as cidades"][0] !== "TODOS") {
        setSelecionados(prev => ({
          ...prev,
          "Escolha as cidades": ["TODOS"]
        }));
      }
    } else {
      cidadesFiltro.opcoes = ["TODOS"];
      selecionados["Escolha os estados"].forEach(uf => {
        if (filtersRequest.data && filtersRequest.data[uf]) {
          cidadesFiltro.opcoes.push(...filtersRequest.data[uf]);
        }
      });
    }

    forceUpdate();
  };

  useEffect(() => {
    updateFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selecionados["Escolha os estados"], selecionados["Escolha a região"]]);

  const handleCheckbox = (filtro, opcao) => {
    setSelecionados(prev => {
      let novosSelecionados;

      if (filtro === "Escolha a situação") {
        novosSelecionados = [opcao];
      } else {
        const todasOpcoes = filtro.titulo === "Escolha a situação" ? ["Notificações"] : ["TODOS"];
        const ehOpcaoTodas = todasOpcoes.includes(opcao);
        const jaSelecionado = prev[filtro]?.includes(opcao);

        if (ehOpcaoTodas) {
          novosSelecionados = jaSelecionado ? [] : [opcao];
        } else {
          novosSelecionados = jaSelecionado
            ? prev[filtro].filter(o => o !== opcao)
            : [...prev[filtro].filter(o => !todasOpcoes.includes(o)), opcao];
        }
      }

      return {
        ...prev,
        [filtro]: novosSelecionados
      };
    });
  };

  const isChecked = (filtro, opcao) => {
    return selecionados[filtro]?.includes(opcao);
  };

  const UseFilter = () => {
    const selectedFilters = {
      SITUACAO: selecionados["Escolha a situação"].map(value => {
        let transformedValue = value;
        if (value === "Notificações") {
          transformedValue = "TODOS";
        } else if (value === "Interrupções de tratamento") {
          transformedValue = "ABANDONO";
        } else if (value === "Óbitos") {
          transformedValue = "OBITO";
        }
        return { value: transformedValue, label: value };
      }),
      ANO_DIAG: selecionados["Escolha os anos"].map(value => ({ value, label: value })),
      CS_RACA: selecionados["Escolha raças"].map(value => ({ value, label: value })),
      CS_SEXO: selecionados["Escolha o Gênero"].map(value => ({ value, label: value })),
      FAIXA_ET: selecionados["Escolha as faixas etárias"].map(value => ({ value, label: value })),
      SIGLA_UF: selecionados["Escolha os estados"].map(value => ({ value, label: value })),
      REGIAO: selecionados["Escolha a região"].map(value => ({ value, labe: value })),
      NOME_MUNIC: selecionados["Escolha as cidades"].map(value => ({ value, label: value })),
    };

    Object.keys(selectedFilters).forEach(key => {
      if (selectedFilters[key].length === 0) {
        selectedFilters[key] = [{ value: "TODOS", label: "TODOS" }];
      }
    });
    useData(
      selectedFilters.SITUACAO,
      selectedFilters.ANO_DIAG,
      selectedFilters.CS_RACA,
      selectedFilters.CS_SEXO,
      selectedFilters.FAIXA_ET,
      selectedFilters.SIGLA_UF,
      selectedFilters.REGIAO,
      selectedFilters.NOME_MUNIC
    );
  }

  return (
    <div className={`${open ? "on show container-fluid mt-4" : "on hide container-fluid mt-4"}`}>
      <div className="d-flex overflow-auto gap-3 pb-2">
        {filters.map((filtro, index) => (
          <div key={index} className="card" style={{ minWidth: "250px", maxHeight: "300px", overflowY: "auto" }}>
            <div className="card-body" style={{ boxShadow: "none" }}>
              <h5 className="card-title">{filtro.titulo}</h5>
              <div>
                {filtro.opcoes.map((opcao, i) => (
                  <div key={i} className={"form-check mb-1 "}>
                    <input
                      className="form-check-input"
                      type={filtro.titulo === "Escolha a situação" ? "radio" : "checkbox"}
                      name={filtro.titulo === "Escolha a situação" ? filtro.titulo : undefined}
                      id={`${filtro.titulo}-${opcao}`}
                      checked={isChecked(filtro.titulo, opcao)}
                      onChange={() => handleCheckbox(filtro.titulo, opcao)}
                    />
                    <label className="form-check-label" htmlFor={`${filtro.titulo}-${opcao}`}>
                      {opcao}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-end mt-3">
        <button className="btn btn-primary" onClick={UseFilter}>Aplicar</button>
      </div>
    </div >
  );
};

export default Filters;
